import React from 'react'
import './Ministries.css'
import '../../../App.css'
import '../SubLinks.css'
import MinistryLinks from '../MinistryLinks';
import { Link } from 'react-router-dom'

function Outreach() {
  return (
    <div>
            <div className='hero-container outreach half'>
                <h1></h1>
            </div>
    <div className='main-grid-container'>
      <div className='main-grid-item'>
    <MinistryLinks/>
    </div>
    <div className='main-grid-item'>
    <div className='main with-sublinks'>
            <h1>Outreach</h1>

            <div className='blockquote-container'>
                    <blockquote>How then will they call on him in whom they have not believed? And how are they to believe in him of whom they have never heard? And how are they to hear without someone preaching? And how are they to preach unless they are sent? As it is written, “How beautiful are the feet of those who preach the good news!.
                        <cite> - Romans 10:14 -15</cite>
                    </blockquote>
                    </div>

            <h2>Bible Ministry</h2>
            <p>
              One of the greatest treasures we have is the Word of God, and we have plenty of Bibles available for you to use and distribute at no cost. Each Bible comes with a clear presentation of the gospel of Jesus Christ attached to the inner cover. If you are in need of a Bible please <Link to='/contact-us' className='p-link'>contact us</Link>.
            </p>
            <h2>VBS Ministry</h2>
            <p>
            Each summer we provide a vacation Bible School for ages 6-12 in our community.  In this unstable world, it is our desire to be shade for children by helping them to learn about their Creator and His love for them. If you would like your children to attend please <Link to='/contact-us' className='p-link'>contact the church</Link> and we’ll be happy to provide you with more information.
            </p>
            <h2>Prison Ministry</h2>
            <p>
            We understand the difficult and often traumatic reality of having someone you care for incarcerated. It’s our desire to provide sound bible teaching, prayer and Bibles to many of those who spend time in the County and local Jails. If you have someone in the Williamson County Jail system that needs a visit, please <Link to='/contact-us' className='p-link'>contact us</Link>, we have workers that regularly visit and lead Bible studies for both the men and women.
            </p>
            <h2>Foreign Missions Work</h2>
            <p>
            GCF partners with missionaries and training centers around the world to further the Kingdom of God. It’s been our joy to journey into the mountainous regions of Honduras to preach the gospel, provide medical care, minister to children, and meet many other practical needs to help to strengthen the local churches. We also participate in helping to train local men through the Ministerios Evangélicos de las Américas training center.
We also work in partnership with The Master's Academy International to support pastoral training centers around the world. For additional information in TMAI you can <Link to='https://www.tmai.org/' className='p-link' target='_blank'>click here</Link>.
            </p>
        </div>
      
    </div>
    </div>
    </div>
  )
}

export default Outreach
